const TRIM_END_PATTERN = /\/$/;
const TRIM_START_PATTERN = /^\//;

function withBaseUrl(path, baseUrl) {
  if (baseUrl) {
    baseUrl = baseUrl.replace(TRIM_END_PATTERN, '');
    path = path.replace(TRIM_START_PATTERN, '');
    return `${baseUrl}/${path}`;
  }
  return path;
}

export default withBaseUrl;
